export default __webpack_public_path__ + "static/media/engine-distance.c3427bee.svg";